import { useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useStore } from 'models/stores';

export function useEnterpriseFilters() {
  const [searchParams, setSearchParams] = useSearchParams();
  const {
    uiStore: { t },
  } = useStore();
  const [searchValue, setSearchValue] = useState('');

  const searchString = searchValue.toLowerCase().trim().replace(new RegExp(' ', 'g'), '');
  const departments = searchParams.getAll('department');
  const statuses = searchParams.getAll('status');

  const statusTypes = useMemo(() => {
    return [
      { value: 'full_time', display: t('jobStatus_full_time') },
      { value: 'part_time', display: t('jobStatus_part_time') },
    ];
  }, [t]);

  function selectDepartment(department: Record<string, boolean>) {
    setSearchParams({
      department: Object.keys(department).filter((key) => department[key]),
      status: statuses,
    });
  }

  function selectStatus(status: Record<string, boolean>) {
    setSearchParams({
      status: Object.keys(status).filter((key) => status[key]),
      department: departments,
    });
  }

  function clearFilters() {
    setSearchValue('');
    setSearchParams({});
  }

  return {
    searchString,
    selectDepartment,
    selectStatus,
    clearFilters,
    selectedDepartments: departments,
    selectedStatuses: statuses,
    searchValue,
    setSearchValue,
    statusTypes,
  };
}
